const widthColumn = 100;
const widthCostColumn = 170;
const widthThongKeBaoCao = 120;

const header = {
  category: [
    { name: 'Stt', width: 45 },
    { name: 'Tên', width: 220 },
    { name: 'Danh mục cha', width: 220 },
    { name: 'Mô tả' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  categoryGroup: {
    competence: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 220 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 170, minWidth: 170 }
    ],
    capNhatNguoiDung: [
      { name: 'Stt', width: 45 },
      { name: 'Tên công chức' },
      { name: 'Vai trò', width: 220 },
      { name: 'Thao tác', width: 170, minWidth: 170 }
    ],
    capNhatNguoiDungXLD: [
      { name: 'STT', width: 45 },
      { name: 'Mã tra cứu', width: 70 },
      { name: 'Ngày tiếp nhận', width: 110 },
      { name: 'Người đứng đơn', width: 170 },
      { name: 'Tóm tắt nội dung', minWidth: 120 },
      { name: 'Phân loại đơn/ Số người', width: 170 },
      { name: 'Nguồn đơn', width: 85 },
      { name: 'Tình trạng xử lý/Kết quả xử lý', width: 190 }
    ],
    donViNgoai: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 220 },
      { name: 'Thao tác', width: 170, minWidth: 170 }
    ],
    documentType: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 220 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 170, minWidth: 170 }
    ],
    letters: [
      { name: 'Stt', width: 45 },
      { name: 'Mã', width: 70 },
      { name: 'Tên', width: 220 },
      { name: 'Lĩnh vực đơn thư cha', width: 220 },
      { name: 'Loại đơn' },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 150, minWidth: 150 }
    ],
    administrative: [
      { name: 'Stt', width: 45 },
      { name: 'Mã', width: 70 },
      { name: 'Tên', width: 190 },
      { name: 'Đơn vị hành chính cha', width: 190 },
      { name: 'Cấp đơn vị hành chính', width: 170 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 130, minWidth: 130 }
    ],
    organizationlevel: [
      { name: 'Stt', width: '44px' },
      { name: 'Mã', width: 70 },
      { name: 'Tên', width: 200 },
      { name: 'Cấp cơ quan cha', width: 200 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 130, minWidth: 130 }
    ],
    organization: [
      { name: 'Stt', width: 45 },
      { name: 'Mã', width: 70 },
      { name: 'Tên', width: 200 },
      { name: 'Cơ quan quản lý cha', width: 200 },
      { name: 'Cấp cơ quan quản lý', width: 200 },
      { name: 'Đơn vị hành chính', width: 200 },
      { name: 'Mô tả', minWidth: 200 },
      { name: 'Thao tác', width: 150, minWidth: 150 }
    ],
    residentialgroup: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 200 },
      { name: 'Đơn vị hành chính', width: 200 },
      { name: 'Mô tả', },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    nation: [
      { name: 'Stt', width: 45 },
      { name: 'Mã', width: 70 },
      { name: 'Tên dân tộc', width: 140 },
      { name: 'Tên khác', width: 350 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    citizen: [
      { name: 'Stt', width: 45 },
      { name: 'Họ và tên', width: 160 },
      { name: 'Thông tin cá nhân' },
      { name: 'Giới tính', width: 70 },
      { name: 'CMND/Hộ chiếu', width: 160 },
      { name: 'Dân tộc', width: 100 },
      { name: 'Quốc tịch', width: 100 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    position: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 300 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    role: [
      { name: 'Stt', width: 45 },
      { name: 'Tên' },
      { name: 'Loại vai trò' },
      { name: 'Mô tả', width: 500 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    civilServant: [
      { name: 'Stt', width: 45 },
      { name: 'Họ và tên', width: 160 },
      { name: 'Email/ Điện thoại', width: 210 },
      { name: 'Đơn vị công tác', width: 160 },
      { name: 'Vai trò', width: 160 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    typeoftimeout: [
      { name: 'Stt', width: 45 },
      { name: 'Số ngày', width: 100 },
      { name: 'Loại thời hạn', width: '' },
      { name: 'Thao tác', width: 100 }
    ],
    parameter: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 300 },
      { name: 'Giá trị', width: 110 },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    quytrinh: [
      { name: 'Stt', width: 45 },
      { name: 'Tên đơn vị', width: 300 },
      { name: 'Tên quy trình', width: 110 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    cauHinhBaoCao: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 200 },
      { name: 'Ngày bắt đầu' },
      { name: 'Ngày kết thúc' },
      { name: 'Năm báo cáo' },
      { name: 'Đơn vị gửi' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    video: [
      { name: 'Stt', width: 45 },
      { name: 'Tên', width: 200 },
      { name: 'Danh mục' },
      { name: 'Loại video' },
      { name: 'File' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    coquanthanhtratw: [
      { name: 'STT', width: '5%' },
      { name: 'Mã', width: '25%' },
      { name: 'Tên', width: '30%' },
      { name: 'Mô tả', width: '30%' },
      { name: 'Thao tác', width: '10%' },
    ]
  },
  administrativeunits: [
    { name: 'Stt', width: 45 },
    { name: 'Mã', width: 70 },
    { name: 'Tên', width: 190 },
    { name: 'Mô tả' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  nationality: [
    { name: 'Stt', width: 45 },
    { name: 'Mã', width: 70 },
    { name: 'Tên', width: 300 },
    { name: 'Mô tả' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  typeoforganizationlevel: [
    { name: 'Stt', width: 45 },
    { name: 'Tên', width: 300 },
    { name: 'Mô tả' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  addReception: {
    groupMember: [
      { name: 'STT', width: 44 },
      { name: 'Họ và tên', width: 160 },
      { name: 'CMND/Hộ chiếu', width: 160 },
      { name: 'Địa chỉ', minWidth: 302 },
      { name: 'Điện thoại', width: 160 },
      { name: 'Thao tác', width: 100 }
    ],
    boSungTaiLieu: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 300 },
      { name: 'Tình trạng', width: 201 },
      { name: 'Tập tin đính kèm', minWidth: 275, colSpan: 2 }
    ],
    danhSachBangChung: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 165, minWidth: 165 },
      { name: 'Tình trạng', width: 200 },
      { name: 'Tập tin đính kèm', minWidth: 175 },
      { name: 'Thao tác', width: 110, minWidth: 110 },
    ],
    searchName: [
      { name: 'Stt', width: 45 },
      { name: 'Tên người đứng đơn', width: 137 },
      { name: 'CMND/Hộ chiếu', width: 115 },
      { name: 'Địa chỉ', width: '' },
      { name: 'Số điện thoại', width: 85 },
      { name: 'Số đơn', width: 58 },
      { name: 'Thao tác', width: 230 }
    ]
  },
  detailReception: {
    groupMember: [
      { name: 'STT', width: 45 },
      { name: 'Họ và tên', width: 165 },
      { name: 'CMND/Hộ chiếu', width: 115 },
      { name: 'Địa chỉ', minWidth: 300 },
      { name: 'Điện thoại', width: 145 }
    ],
    proof: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 400 },
      { name: 'Tình trạng', width: 175 },
      { name: 'Tập tin đính kèm', minWidth: 280 }
    ],
    boSungTaiLieu: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 400 },
      { name: 'Số trang', width: 70 },
      { name: 'Loại tài liệu', width: 175 },
      { name: 'Tình trạng', width: 175 },
      { name: 'Tập tin đính kèm', minWidth: 280, colSpan: 2 }
    ]
  },
  receptionPeriodical: {
    add: [
      { name: 'STT', width: 45 },
      { name: 'Tên cơ quan, đơn vị', width: 300 },
      { name: 'Người đại diện', width: 200 },
      { name: 'Chức vụ', width: 200 },
      { name: 'Thao tác', width: 53 }
    ],
    listBriefJob: [
      { selectAll: true, width: 60 },
      { name: 'STT', width: 45 },
      { name: 'Ngày tiếp nhận', width: 110 },
      { name: 'Người đứng đơn', width: 235 },
      { name: 'Tóm tắt vụ việc', minWidth: 175 },
      { name: 'Phân loại đơn/ Số người', width: 185 },
      { name: 'Cơ quan đã giải quyết', width: 150 }
    ],
    listHome: [
      { name: 'Stt', width: 45 },
      { name: 'Ngày tiếp', width: 135 },
      { name: 'Người đứng đơn', width: 170 },
      { name: 'Tóm tắt nội dung', minWidth: 120 },
      { name: 'Phân loại đơn/ Số người', width: 170 },
      { name: 'Cơ quan đã giải quyết', width: 150 },
      { name: 'Lãnh đạo tiếp', width: 140 },
      { name: 'Kết quả tiếp dân', width: 125 },
      { name: 'Tình trạng xử lý', width: 115 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    listYeuCau: [
      { name: 'Stt', width: 45 },
      { name: 'Ngày tiếp', width: 110 },
      { name: 'Người đứng đơn', width: 170 },
      { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 },
      { name: 'Phân loại đơn/ Số người', width: 170 },
      { name: 'Nguồn đơn', width: 85 },
      { name: 'Cơ quan đã giải quyết', width: 150 },
      { name: 'Trạng thái', width: 190 },
      { name: 'Thao tác', width: 110, minWidth: 110 },
    ]
  },
  listTCD: [
    { name: 'Stt', width: 45 },
    { name: 'Ngày tiếp', width: 115 },
    { name: 'Người đứng đơn', width: 170 },
    { name: 'Tóm tắt nội dung', minWidth: 140 },
    { name: 'Phân loại đơn/ Số người', width: 130 },
    { name: 'Cơ quan đã giải quyết', width: 120 },
    { name: 'Công chức tiếp dân', width: 110 },
    { name: 'Lượt tiếp', width: 72 },
    { name: 'Hướng xử lý', width: 104 },
    { name: 'Tình trạng xử lý/Kết quả xử lý', width: 160 },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  listXLD: [
    { name: 'Stt', width: 45 },
    { name: 'Mã tra cứu', width: 70 },
    { name: 'Ngày tiếp nhận', width: 110 },
    { name: 'Người đứng đơn', width: 170 },
    { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 },
    { name: 'Phân loại đơn/ Số người', width: 170 },
    { name: 'Nguồn đơn', width: 85 },
    { name: 'Cơ quan đã giải quyết', width: 150 },
    { name: 'Tình trạng xử lý/Kết quả xử lý', width: 190 },
    { name: 'Lãnh đạo/Công chức xử lý', width: 150 },
    { name: 'Thao tác', width: 110, minWidth: 110 },
  ],
  listXLDC: [
    { name: 'Stt', width: 45 },
    { name: 'Người đứng đơn', width: 170 },
    { name: 'Tóm tắt nội dung', minWidth: 120 },
    { name: 'Phân loại đơn/ Số người', width: 170 },
    { name: 'Nguồn đơn', width: 85 },
    { name: 'Loại thông tin đơn', width: 100 },
    { name: 'Thao tác', width: 110, minWidth: 110 },
  ],
  listTCDDX: [
    { name: 'Stt', width: 45 },
    { name: 'Ngày tiếp', width: 135 },
    { name: 'Người đứng đơn', width: 170 },
    { name: 'Tóm tắt nội dung', minWidth: 120 },
    { name: 'Phân loại đơn/ Số người', width: 170 },
    { name: 'Cơ quan đã giải quyết', width: 150 },
    { name: 'Lãnh đạo tiếp', width: 140 },
    { name: 'Kết quả tiếp dân', width: 125 },
    { name: 'Tình trạng xử lý', width: 115 },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  listTTXLGQD: [
    { name: 'Stt', width: 45 },
    { name: 'Đơn vị xử lý', width: 300 },
    { name: 'Hướng xử lý', width: 170 },
    { name: 'File đính kèm' },
  ],
  detailReceptionPeriodical: {
    organization: [
      { name: 'STT', width: 44 },
      { name: 'Tên cơ quan, đơn vị' },
      { name: 'Người đại diện' },
      { name: 'Chức vụ' }
    ],
    proof: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu' },
      { name: 'Tình trạng' },
      { name: 'Tập tin đính kèm' }
    ],
    attach: [
      { name: 'Stt', width: 45 },
      { name: 'Tên biểu mẫu', width: 300 },
      { name: 'Số quyết định' },
      { name: 'Ngày quyết định' },
      { name: 'Tập tin đính kèm' }
    ],
    tepDinhKem: [
      { name: 'Stt', width: 45 },
      { name: 'Tên biểu mẫu' },
      { name: 'Loại tệp', width: 100 },
      { name: 'Số quyết định', width: 100 },
      { name: 'Ngày quyết định', width: 115 },
      { name: 'Tập tin đính kèm' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ]
  },
  home: {
    letterTable: [
      { name: 'Stt', width: 45 },
      { name: 'Ngày tiếp nhận', width: 110 },
      { name: 'Người đứng đơn', minWidth: 150 },
      { name: 'Tóm tắt nội dung', minWidth: 150 }
    ]
  },
  giaiQuyetDon: {
    listGQD: [
      { name: 'Stt', width: 45 },
      { name: 'Mã tra cứu', width: 70 },
      { name: 'Ngày tiếp nhận', width: 110 },
      { name: 'Người đứng đơn', width: 170 },
      { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 },
      { name: 'Phân loại đơn/ Số người', width: 170 },
      { name: 'Nguồn đơn', width: 85 },
      { name: 'Cơ quan đã giải quyết', width: 150 },
      { name: 'Tình trạng giải quyết/Kết quả giải quyết', width: 250 },
      { name: 'Lãnh đạo/Công chức giải quyết', width: 190 },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    listDonDaGQ: [
      { name: 'Stt', width: 45 },
      { name: 'Mã tra cứu', width: 70 },
      { name: 'Ngày tiếp nhận', width: 110 },
      { name: 'Người đứng đơn', width: 170 },
      { name: 'Tóm tắt nội dung/ Hạn xử lý', minWidth: 120 },
      { name: 'Phân loại đơn/ Số người', width: 170 },
      { name: 'Nguồn đơn', width: 85 },
      { name: 'Cơ quan đã giải quyết', width: 150 },
      { name: 'Tình trạng giải quyết/Kết quả giải quyết', width: 250 },
      { name: 'Lãnh đạo/Công chức giải quyết', width: 190 }
    ],
    danhSachTaiLieuDinhKem: [
      { name: 'Stt', width: 45 },
      { name: 'Tên biểu mẫu', width: 300 },
      { name: 'Số quyết định' },
      { name: 'Ngày quyết định' },
      { name: 'Tài liệu đính kèm' },
    ],
    danhSachTaiLieuDinhKemDC: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 300 },
      { name: 'Số văn bản' },
      { name: 'Ngày ra văn bản' },
      { name: 'Tài liệu đính kèm' },
    ],
    taiLieuDinhKem: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu', width: 300 },
      { name: 'Số quyết định' },
      { name: 'Ngày quyết định' },
      { name: 'Tài liệu đính kèm' },
      { name: 'Thao tác', width: 110, minWidth: 110 }
    ],
    danhSachBangChung: [
      { name: 'Stt', width: 45 },
      { name: 'Tên tài liệu' },
      // {name: 'Số trang', width: 100},
      // {name: 'Loại tài liệu', width: 190},
      { name: 'Tình trạng' },
      { name: 'Tập tin đính kèm' }
    ]
  },
  dialogHistory: [
    { name: 'Stt', width: 45 },
    { name: 'Nội dung', width: 405 },
    { name: 'Người xử lý', width: 300 },
    { name: 'Thao tác', width: 175 }
  ],
  dialogHistoryXL: [
    { name: 'Stt', width: 45 },
    { name: 'Nội dung', width: 405 },
    { name: 'Người xử lý', width: 300 },
    { name: 'Thao tác', width: 175 }
  ],
  dialogHistoryDetail: [
    { name: 'Stt', width: 45 },
    { name: 'Nội dung', width: 405 },
    { name: 'Thông tin cũ', width: 300 },
    { name: 'Thông tin mới', width: 300 }
  ],
  thongKeBaoCaoTiepCongDan: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'TIẾP THƯỜNG XUYÊN', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'TIẾP ĐỊNH KỲ VÀ ĐỘT XUẤT CỦA LÃNH ĐẠO', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'NỘI DUNG TIẾP CÔNG DÂN (số vụ việc)', className: 'middle-content', colSpan: 14, rowSpan: 1 },
      { name: 'KẾT QUẢ QUA TIẾP DÂN (số vụ việc)', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Lượt', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đoàn đông người', colSpan: 4, rowSpan: 1, className: 'middle-content' },

      { name: 'Lượt', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đoàn đông người', colSpan: 4, rowSpan: 1, className: 'middle-content' },

      { name: 'Khiếu nại', colSpan: 7, rowSpan: 1, className: 'middle-content' },
      { name: 'Tố cáo', colSpan: 6, rowSpan: 1, className: 'middle-content' },
      { name: 'Phản ánh, kiến nghị, khác', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Chưa được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã được giải quyết', colSpan: 3, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Cũ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Mới phát sinh', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Cũ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Mới phát sinh', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Vụ việc', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Lĩnh vực hành chính', colSpan: 5, rowSpan: 1, className: 'middle-content' },
      { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực hành chính', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tham nhũng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực khác', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Chưa có QĐ giải quyết', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã có QĐ giải quyết (lần 1,2, cuối cùng)', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã có bản án của Tòa', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

    ],
    [
      { name: 'Cũ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Mới phát sinh', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Cũ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Mới phát sinh', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Liên quan đến đất đai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về nhà, tài sản', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về chính sách, chế độ CC,VC', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực CT,VH,XH khác', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
    ]
  ],
  thongKeBaoCaoXuLyDon: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'TIẾP NHẬN', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'PHÂN LOẠI ĐƠN KHIẾU NẠI, TỐ CÁO', className: 'middle-content', colSpan: 18, rowSpan: 1 },
      { name: 'ĐƠN KHÁC (kiến nghị, phản ánh, đơn nặc danh)', className: 'middle-content', colSpan: 1, rowSpan: 5, width: widthColumn, minWidth: widthColumn },
      { name: 'KẾT QUẢ XỬ LÝ ĐƠN KHIẾU NẠI, TỐ CÁO', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 5, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số đơn', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn tiếp nhận trong kỳ', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Đơn kỳ trước chuyển sang', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Đơn đủ điều kiện xử lý', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Theo nội dung', colSpan: 13, rowSpan: 1, className: 'middle-content' },
      { name: 'Theo thẩm quyền giải quyết', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Theo trình tự giải quyết', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Số văn bản hướng dẫn', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đơn chuyển cơ quan có thẩm quyền', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số công văn đôn đốc việc giải quyết', colSpan: 1, rowSpan: 4, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn thuộc thẩm quyền', colSpan: 2, rowSpan: 2, className: 'middle-content' }
    ],
    [
      { name: 'Khiếu nại', colSpan: 7, rowSpan: 1, className: 'middle-content' },
      { name: 'Tố cáo', colSpan: 6, rowSpan: 1, className: 'middle-content' },

      { name: 'Của các cơ quan hành chính các cấp', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Của cơ quan tư pháp các cấp', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Của cơ quan Đảng', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Chưa được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã được giải quyết', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }
    ],
    [
      { name: 'Đơn có nhiều người đứng tên  ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn một người đứng tên', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn có nhiều người đứng tên  ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn một người đứng tên', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Lĩnh vực hành chính', colSpan: 5, rowSpan: 1, className: 'middle-content' },
      { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },


      { name: 'Tổng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực hành chính', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực tư pháp', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tham nhũng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về Đảng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực khác', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Khiếu nại', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tố cáo', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' }
    ],
    [
      { name: 'Tổng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Liên quan đến  đất đai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về nhà, tài sản', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Về chính sách, chế độ CC,VC', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Lĩnh vực CT,VH,XH khác', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }
    ]
  ],
  thongKeBaoCaoGiaiQuyetDonKN: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'ĐƠN KHIẾU NẠI THUỘC THẨM QUYỀN', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KẾT QUẢ GIẢI QUYẾT', className: 'middle-content', colSpan: 21, rowSpan: 1 },
      { name: 'CHẤP THÀNH THỜI GIAN GIẢI QUYẾT THEO QUY ĐỊNH', className: 'middle-content', colSpan: 2, rowSpan: 2 },
      { name: 'VIỆC THI HÀNH QUYẾT ĐỊNH GIẢI QUYẾT KHIẾU NẠI', className: 'middle-content', colSpan: 10, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số đơn khiếu nại', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Trong đó', colSpan: 3, rowSpan: 2, className: 'middle-content' },

      { name: 'Đã giải quyết', colSpan: 4, rowSpan: 2, className: 'middle-content' },
      { name: 'Phân tích kết quả (vụ việc)', colSpan: 6, rowSpan: 1, className: 'middle-content' },
      { name: 'Kiến nghị thu hồi cho Nhà nước', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Trả lại cho công dân', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Số người được trả lại quyền lợi', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Kiến nghị xử lý hành chính', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra, khởi tố', colSpan: 4, rowSpan: 1, className: 'middle-content' },

      { name: 'Tổng số quyết định phải tổ chức thực hiện trong kỳ báo cáo', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đã thực hiện', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Thu hồi cho nhà nước', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Trả lại cho công dân', colSpan: 4, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Khiếu nại đúng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Khiếu nại sai', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Khiếu nại đúng một phần', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Giải quyết lần 1', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Giải quyết lần 2', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Số vụ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đối tượng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Kết quả', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Số vụ việc giải quyết đúng thời hạn', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Số vụ việc giải quyết quá thời hạn', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Phải thu', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã thu', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Phải trả', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Đơn nhận trong kỳ báo cáo', width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Đơn tồn kỳ trước chuyển sang', width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số vụ việc', width: 100, minWidth: 100, className: 'middle-content' },

      { name: 'Số đơn thuộc thẩm quyền', width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Số vụ việc thuộc thẩm quyền', width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Số vụ việc giải quyết bằng QĐ hành chính', width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Số vụ việc rút đơn thông qua giải thích, thuyết phục', width: 100, minWidth: 100, className: 'middle-content' },

      { name: 'Công nhận QĐ g/q lần 1', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Hủy, sửa QĐ g/q lần 1', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng số người', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số người đã bị xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Số vụ đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đối tượng đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }
    ]
  ],
  thongKeBaoCaoGiaiQuyetDonTC: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'ĐƠN TỐ CÁO THUỘC THẨM QUYỀN', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KẾT QUẢ GIẢI QUYẾT', className: 'middle-content', colSpan: 16, rowSpan: 1 },
      { name: 'CHẤP THÀNH THỜI GIAN GIẢI QUYẾT THEO QUY ĐỊNH', className: 'middle-content', colSpan: 2, rowSpan: 2 },
      { name: 'VIỆC THI HÀNH QUYẾT ĐỊNH XỬ LÝ TỐ CÁO', className: 'middle-content', colSpan: 10, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số đơn tố cáo', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Trong đó', colSpan: 3, rowSpan: 2, className: 'middle-content' },

      { name: 'Đã giải quyết', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Phân tích kết quả (vụ việc)', colSpan: 3, rowSpan: 2, className: 'middle-content' },
      { name: 'Kiến nghị thu hồi cho Nhà nước', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Trả lại cho công dân', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Số người được trả lại quyền lợi', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Kiến nghị xử lý hành chính', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra, khởi tố', colSpan: 4, rowSpan: 1, className: 'middle-content' },

      { name: 'Tổng số quyết định phải tổ chức thực hiện trong kỳ báo cáo', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã thực hiện xong', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Thu hồi cho nhà nước', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Trả lại cho công dân', colSpan: 4, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Số vụ', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đối tượng', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Kết quả', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Số vụ việc giải quyết đúng thời hạn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số vụ việc giải quyết quá thời hạn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Phải thu', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã thu', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Phải trả', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã trả', colSpan: 2, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Đơn nhận trong kỳ báo cáo', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đơn tồn kỳ trước chuyển sang', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tổng số vụ việc', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Số đơn thuộc thẩm quyền', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số vụ việc thuộc thẩm quyền', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tố cáo đúng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tố cáo sai', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tố cáo đúng một phần', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng số người', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số người đã bị xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Số vụ đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Số đối tượng đã khởi tố', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tiền (Trđ)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' }
    ]
  ],
  quanLyNhaNuocVeKhieuNaiToCao: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'BAN HÀNH VĂN BẢN QUẢN LÝ, CHỈ ĐẠO (Bộ, ngành, tỉnh, TP) VỀ CÔNG TÁC KNTC', colSpan: 2, rowSpan: 1 },
      { name: 'TẬP HUẤN, TUYÊN TRUYỀN, GIÁO DỤC PHÁP LUẬT VỀ KNTC CHO CÁN BỘ, CÔNG CHỨC, VIÊN CHỨC, NHÂN DÂN', colSpan: 2, rowSpan: 1 },
      { name: 'THANH TRA, KIỂM TRA TRÁCH NHIỆM', colSpan: 7, rowSpan: 1 },
      { name: 'KIỂM TRA VIỆC THỰC HIỆN KẾT LUẬN THANH TRA TRÁCH NHIỆM, QUYẾT ĐỊNH XỬ LÝ', colSpan: 5, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Số văn bản ban hành mới', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Số văn bản được sửa đổi, bổ sung', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Pháp luật về KNTC', colSpan: 2, rowSpan: 1 },
      { name: 'Thực hiện pháp luật về KNTC', colSpan: 2, rowSpan: 1 },
      { name: 'Số đơn vị có vi phạm', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Kiến  nghị xử lý', colSpan: 4, rowSpan: 1 },
      { name: 'Tổng số KLTT và QĐ xử lý đã kiểm tra', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Kết quả kiểm tra', colSpan: 4, rowSpan: 1 }
    ],
    [
      { name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1 },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1 },

      { name: 'Đã kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1 },
      { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1 }
    ],
    [
      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao }
    ]
  ],
  // Thanh tra hành chính
  thongKeBaoCaoThanhTraHanhChinh: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Số đơn vị được thanh tra theo kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiền và tài sản quy thành tiền (tr.đ)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
    ],
  ],
  thongKeBaoCaoThanhTraDatDai: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
    ],
  ],
  thongKeBaoCaoThanhTraChuyenNganh: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'SỐ CUỘC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 3, rowSpan: 1 },
      { name: 'SỐ CÁ NHÂN ĐƯỢC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 },
      { name: 'SỐ TỔ CHỨC ĐƯỢC THANH TRA, KIỂM TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 },
      { name: 'KẾT QUẢ', className: 'middle-content', colSpan: 19, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Thành lập đoàn', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Thanh tra độc lập', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Số có vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số QĐ xử phạt hành chính được ban hành', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tiền vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' },

      { name: 'Số tiền kiến nghị thu hồi', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Số tiền xử lý tài sản vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tiền xử phạt vi phạm', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tiền đã thu', colSpan: 3, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Thanh tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Kiểm tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Thanh tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Kiểm tra', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổng số', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổng số', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },


      { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tịch thu (thành tiền)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiêu hủy (thành tiền)', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng số', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tổ chức', width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
    ]
  ],
  thongKeBaoCaoThucHienKetLuanThanhTraHanhchinh: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Kết luận thanh tra phải thực hiện', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Tiến độ thực hiện kết luận', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Thu hồi về ngân sách nhà nước', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'Xử lý khác về kinh tế', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'Xử lý hành chính', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'Hoàn thiện về cơ chế chính sách (số văn bản)', className: 'middle-content', colSpan: 2, rowSpan: 1 },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Trong đó số kết luận chưa thực hiện xong kỳ trước chuyển sang', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Số kết luận đã hoàn thành', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Số kết luận chưa hoàn thành', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Tổng số phải xử lý', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Xử lý trong kỳ', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Khởi tố trong kỳ', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Tổng số văn bản kiến nghị phải hoàn thiện', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Số văn bản kiến nghị đã thực hiện xong', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
    ],
    [
      { name: 'Tổng số tiền phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Số tiền đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Tổng số đất phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Số đất đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Tổng số tiền phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Số tiền đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Tổng số đất phải thu', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Số đất đã thu trong kỳ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 90, minWidth: 90, className: 'middle-content' },
    ]
  ],
  thongKeBaoCaoThanhTraXayDungCoBan: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
    ],
  ],
  thongKeBaoCaoThanhTraTaiChinhNganSach: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'Số cuộc thanh tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Số đơn vị được thanh tra', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Tổng vi phạm về kinh tế', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'Kiến nghị xử lý', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'Hoàn thiện cơ chế, chính sách (số văn bản)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 123, maxWidth: 123, minWidth: 123 },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 85, maxWidth: 85, minWidth: 85 },
      { name: 'Phân loại', colSpan: 4, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiền và tài sản quy thành tiền', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, className: 'middle-content', width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Thu hồi về NSNN', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Xử lý khác về kinh tế', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Theo kế hoạch', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tiền (Tr.đ)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 1, width: 85, maxWidth: 85, minWidth: 85, className: 'middle-content' },
    ],
  ],
  thongKeBaoCaoTongHopKetQuaThanhTraKiemTraChuyenNganh: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Số cuộc thanh tra thực hiện trong kỳ', className: 'middle-content', colSpan: 3, rowSpan: 2, width: widthColumn, minWidth: widthColumn },
      { name: 'Số cuộc thanh tra, kiểm tra đã ban hành kết luận', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 },
      { name: 'Số tổ chức được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 },
      { name: 'Số cá nhân được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 },
      { name: 'Số tổ chức, cá nhân vi phạm', className: 'middle-content', colSpan: 3, rowSpan: 2 },
      { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền) (Tr.đ)', className: 'middle-content', colSpan: 3, rowSpan: 2 },
      { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 3, rowSpan: 2 },
      { name: 'Số tiền kiến nghị xử lý khác', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 85, minWidth: 85 },
      { name: 'Quyết định xử phạt hành chính được ban hành', className: 'middle-content', colSpan: 3, rowSpan: 2 },
      { name: 'Xử phạt vi phạm hành chính', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 2 }
    ],
    [
      { name: 'Bằng tiền', colSpan: 3, rowSpan: 1, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Bằng hình thức khác', colSpan: 3, rowSpan: 1, width: 100, minWidth: 100, className: 'middle-content' },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Phân loại', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100, className: 'middle-content' },
    ],
    [
      // { name: 'Triển khai từ kỳ trước chuyển sang', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      // { name: 'Triển khai trong kỳ', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      // { name: 'Thường xuyên', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Kế hoạch', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Đột xuất', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
    ]
  ],
  thongKeBaoCaoThanhTraLai: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'SỐ CUỘC THANH TRA LẠI', className: 'middle-content', colSpan: 5, rowSpan: 1 },

      { name: 'CĂN CỨ THANH TRA LẠI(SỐ CUỘC)', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'SỐ ĐƠN VỊ ĐÃ THANH TRA LẠI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn },
      { name: 'SỐ ĐƠN VỊ CÓ VI PHẠM PHÁT HIỆN QUA THANH TRA LẠI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn },
      { name: 'VI PHẠM VỀ KINH TẾ PHÁT HIỆN QUA THANH TRA LẠI', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'KIẾN NGHỊ THU HỒI', className: 'middle-content', colSpan: 2, rowSpan: 1 },
      { name: 'KIẾN NGHỊ KHÁC', className: 'middle-content', colSpan: 2, rowSpan: 1 },

      { name: 'KIẾN NGHỊ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KẾT QUẢ THỰC HIỆN', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đang thực hiện', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiến độ', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Vi phạm trình tự, thủ tục dẫn đến sai lệch nghiêm trọng KL', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Nội dung kết luận không phù hợp chứng cứ', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Sai lầm trong áp dụng PL khi KL', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Cố ý làm sai lệch hồ sơ hoặc cố ý KL trái pháp luật, đôn đốc', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Vi phạm nghiêm trọng chưa được phát hiện đầy đủ', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Hành chính', colSpan: 2, rowSpan: 1 },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1 },

      { name: 'Tiền đã thu(trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất đã thu(m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1 },
      { name: 'Đã khởi tố', colSpan: 2, rowSpan: 1 },
    ],
    [
      { name: 'Kỳ trước chuyển sang', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Triển khai trong kỳ báo cáo', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Kết thúc thanh tra trực tiếp', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã ban hành kết luận', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }
    ],
  ],
  thongKeBaoCaoQuyetDinhXuPhatKiemTraChuyenNganh: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 180, maxWidth: 180, minWidth: 180 },
      { name: 'Kết quả thực hiện xử lý vi phạm về kinh tế (Tr,đ)', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'Kết quả thực hiện quyết định xử phạt vi phạm hành chính', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'Đã khởi tố', className: 'middle-content', colSpan: 2, rowSpan: 1 },
    ],
    [
      { name: 'Số tiền vi phạm đã thu hồi (tiền và tài sản quy thành tiền)', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tiền vi phạm đã xử lý khác', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tiền xử phạt vi phạm hành chính đã thu (Tr.đ)', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Số tổ chức, cá nhân đã thực hiện xử phạt vi phạm hành chính bằng hình thức khác', colSpan: 3, rowSpan: 1, className: 'middle-content' },
      { name: 'Vụ', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100, className: 'middle-content' },
      { name: 'Đối tượng', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100, className: 'middle-content' },
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Về ngân sách nhà nước', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Về tổ chức, đơn vị', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Tổ chức', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
      { name: 'Cá nhân', colSpan: 1, rowSpan: 1, width: 85, minWidth: 85, className: 'middle-content' },
    ],
  ],
  ketQuaKiemTraChiTietDoanhNghiep: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40, id: 'idColumn' },
      { name: 'Tên doanh nghiệp được thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 130, maxWidth: 130, minWidth: 130, id: 'nameColumn' },
      { name: 'Nội dung thanh tra, kiểm tra', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 130, maxWidth: 130, minWidth: 130 },
      { name: 'Thời hạn thanh tra, kiểm tra (ngày)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tóm tắt vi phạm phát hiện (nếu có)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiến nghị thu hồi tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Quyết định xử phạm VPHC', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 270, maxWidth: 270, minWidth: 270 },
      { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp...)', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 180, maxWidth: 180, minWidth: 180 },
    ],
    [
      { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Số tiền', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 120, maxWidth: 90, minWidth: 90 },
      { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
    ],
  ],
  ketQuaKiemTraTheoKeHoachDoanhNghiep: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Kế hoạch thanh tra, kiểm tra', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Thực hiện thanh tra, kiểm tra theo kế hoạch', className: 'middle-content', colSpan: 8, rowSpan: 1, width: 400, maxWidth: 400, minWidth: 400 },
      { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Quyết định xử phạt hành chính', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 },
    ],
    [
      { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tỷ lệ thực hiện KH', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
    ],
    [
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
    ]
  ],
  ketQuaKiemTraDotXuatDoanhNghiep: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Thực hiện thanh tra, kiểm tra đột xuất', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Thực hiện thanh tra, kiểm tra đột xuất', className: 'middle-content', colSpan: 3, rowSpan: 1, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 },
    ],
    [
      { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
    ],
    [
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
    ]
  ],
  tongHopKetQuaThanhTra: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 120, maxWidth: 120, minWidth: 120 },
      { name: 'Kế hoạch thanh tra, kiểm tra', className: 'middle-content', colSpan: 6, rowSpan: 2, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Thực hiện thanh tra, kiểm tra theo kế hoạch', className: 'middle-content', colSpan: 10, rowSpan: 1, width: 500, maxWidth: 500, minWidth: 500 },
      { name: 'Số đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tỷ lệ đơn vị vi phạm', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Tổng số tiền vi phạm (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Số tiền kiến nghị thu hồi (tiền và tài sản quy thành tiền)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Kiến nghị xử lý khác (thu hồi đất, ..)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Quyết định xử phạt hành chính', className: 'middle-content', colSpan: 3, rowSpan: 2, width: 300, maxWidth: 300, minWidth: 300 },
      { name: 'Kết quả thực hiện sau thanh tra, kiểm tra (Số tiền thu hồi, phạt VPHC đã nộp)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Chuyển cơ quan điều tra', className: 'middle-content', colSpan: 2, rowSpan: 2, width: 200, maxWidth: 200, minWidth: 200 },
    ],
    [
      { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Theo kế hoạch', className: 'middle-content', colSpan: 4, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 },
      { name: 'Đột xuất', className: 'middle-content', colSpan: 4, rowSpan: 1, width: 200, maxWidth: 200, minWidth: 200 },
    ],
    [
      { name: 'Tổng số', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Thanh tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Kiểm tra', className: 'middle-content', colSpan: 2, rowSpan: 1, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổ chức', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Cá nhân', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Tổng số tiền', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Vụ', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
      { name: 'Đối tượng', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 },
    ],
    [
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số cuộc', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Số đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 50, maxWidth: 50, minWidth: 50 },
    ]
  ],
  thongKe: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 50, maxWidth: 50, minWidth: 50 },
      { name: 'Mã đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 80, maxWidth: 80, minWidth: 80 },
      { name: 'Tên đơn vị', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 250, maxWidth: 250, minWidth: 250 },
      { name: 'Theo kế hoạch', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 600, maxWidth: 600, minWidth: 600 },
      { name: 'Thực hiện', className: 'middle-content', colSpan: 6, rowSpan: 1, width: 520, maxWidth: 520, minWidth: 520 },
    ],
    [
      { name: 'Tổng số DN dự kiến TT, KT', className: 'middle-content', colSpan: 5, rowSpan: 1, width: 450, maxWidth: 450, minWidth: 450 },
      { name: 'Số lần đối tượng được chọn', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 },
      { name: 'Tổng đối tượng đã TT,KT', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 },
      { name: 'Số đối tượng có trong kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 },
      { name: 'Số đối tượng ngoài kế hoạch', className: 'middle-content', colSpan: 1, rowSpan: 2, width: 150, maxWidth: 150, minWidth: 150 },
    ],
    [
      { name: 'Tổng', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Doanh nghiệp', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Cá nhân, HTX', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Cơ sở sản xuất kinh doanh cá thể, hộ kinh doanh', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
      { name: 'Cơ quan HC', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 90, maxWidth: 90, minWidth: 90 },
    ]
  ],
  thanhTra: {
    DSKHTT: [
      { name: 'STT', width: 45 },
      { name: 'Năm thanh tra/kiểm tra', minWidth: 125 },
      { name: 'Quyết định phê duyệt KHTT/KHKT', width: 145 },
      { name: 'Ngày phê duyệt', width: 110 },
      { name: 'Số cuộc TT/KT', width: 75 },
      { name: 'Trạng thái', width: 150 },
      { name: 'Thao tác', width: 135, minWidth: 135 }
    ],
    DSKHTTDPD: [
      { name: 'STT', width: 45 },
      { name: 'Năm thanh tra/kiểm tra', minWidth: 125 },
      { name: 'Quyết định phê duyệt KHTT/KHKT', width: 145 },
      { name: 'Ngày phê duyệt', width: 110 },
      { name: 'Số cuộc TT/KT', width: 75 },
      { name: 'Trạng thái', width: 150 }
    ],
    DKKHTT: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng thanh tra, kiểm tra/Số đối tượng', minWidth: 160 },
      { name: 'Nội dung thanh tra/kiểm tra', minWidth: 160 },
      { name: 'Thời hạn thanh tra/kiểm tra (ngày)', width: 120 },
      { name: 'Thời kỳ thanh tra/kiểm tra', width: 125 },
      { name: 'Thời gian tiến hành', width: 120 },
      // { name: 'Đơn vị chủ trì', minWidth: 90},
      // { name: 'Đơn vị phối hợp', minWidth: 140},
      { name: 'Thao tác', minWidth: 95 }
    ],
    DKKHTT3: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng thanh tra, kiểm tra/Số đối tượng', minWidth: 160 },
      { name: 'Nội dung thanh tra/kiểm tra', minWidth: 160 },
      { name: 'Thời hạn thanh tra/kiểm tra', width: 120 },
      { name: 'Thời kỳ thanh tra/kiểm tra', width: 125 },
      { name: 'Thời gian tiến hành', width: 120 },
      // { name: 'Đơn vị chủ trì', minWidth: 90},
      // { name: 'Đơn vị phối hợp', minWidth: 140}
    ],
    DKKHTT2: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra', minWidth: 90 },
      { name: 'Nội dung thanh tra', minWidth: 160 },
      { name: 'Loại đối tượng/ Hình thức thanh tra', width: 130 },
      { name: 'Thời kỳ thanh tra', width: 125 },
      { name: 'Thời hạn (ngày làm việc)', width: 120 },
      // { name: 'Đơn vị chủ trì', minWidth: 90},
      // { name: 'Đơn vị phối hợp', minWidth: 140},
      { name: 'Thao tác', minWidth: 95 }
    ],
    TMDTTT: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng' },
      /* { name: 'Loại ĐT'},
      { name: 'SĐT'},
      { name: 'Địa chỉ'},
      { name: 'Ngành/Lĩnh vực'},
      { name: 'Ghi chú'}, */
      { name: 'Nhóm đối tượng' },
      { name: 'Mã số thuế' },
      { name: 'Thao tác', width: 70, minWidth: 70 }
    ],
    TMDTTT2: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng' },
      { name: 'Nhóm đối tượng' },
      { name: 'Mã số thuế' },
      { name: 'Huyện/TP' },
      { name: 'Phường/Xã' },
      { name: 'Địa chỉ' },
      { name: 'Thao tác', width: 70, minWidth: 70 },
    ],
    KQTKTMDTTT: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng' },
      /* { name: 'Loại ĐT'},
      { name: 'SĐT'},
      { name: 'Địa chỉ'},
      { name: 'Ngành/Lĩnh vực'},
      { name: 'Ghi chú'}, */
      { name: 'Nhóm đối tượng' },
      { name: 'Mã số thuế' },
    ],
    KQTKTMDTTT2: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng' },
      { name: 'Nhóm đối tượng' },
      { name: 'Mã số thuế' },
      { name: 'Huyện/TP' },
      { name: 'Phường/Xã' },
      { name: 'Địa chỉ' },
    ],
    DSCTT: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra, kiểm tra/Số đối tượng', width: 220 },
      { name: 'Nội dung thanh tra, kiểm tra', minWidth: 80, width: 170 },
      { name: 'Hình thức/Loại hình TT, KT', width: 220 },
      { name: 'Số QĐKHTT/QĐKHKT', width: 120 },
      { name: 'Số QĐ/ Ngày ra QĐ', width: 130 },
      { name: 'Số kết luận TT/Số quyết định XL', width: 220 },
      { name: 'Thời hạn TT/KT', width: 100 },
      { name: 'Tiến độ', width: 140 },
      { name: 'Hoạt động', width: 140 },
      { name: 'Thao tác', minWidth: 100, maxWidth: 135, width: 135 }
    ],
    CTCTT: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng thanh tra', minWidth: 160 },
      { name: 'Nội dung thanh tra', minWidth: 160 },
      { name: 'Chức năng/ Lĩnh vực thanh tra', width: 130 },
      { name: 'Thời hạn (ngày làm việc)', width: 120 },
      { name: 'Thời kỳ thanh tra', width: 125 },
      { name: 'Thời gian tiến hành', width: 120 },
      // { name: 'Đơn vị chủ trì', minWidth: 90},
      // { name: 'Đơn vị phối hợp', minWidth: 140},
    ],
    DSDTT: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra' },
      { name: 'Nội dung thanh tra' },
      { name: 'Hình thức' },
      { name: 'Thời hạn thanh tra' },
      { name: 'Thời kỳ thanh tra' },
      { name: 'Thời gian tiến hành' },
      { name: 'Đơn vị thanh tra' },
      { name: 'Năm thanh tra', width: 150 }
    ],
    CTTVCTT: [
      { name: 'STT', width: 45 },
      { name: 'Họ và tên' },
      { name: 'Ngày sinh' },
      { name: 'Đơn vị' },
      { name: 'Chức vụ' },
      { name: 'Vai trò' }
    ],
    TMTVCTT: [
      { name: 'STT', width: 45 },
      { name: 'Họ và tên' },
      { name: 'Ngày sinh', width: 145, maxWidth: 145, minWidth: 145 },
      { name: 'Đơn vị' },
      { name: 'Chức vụ' },
      { name: 'Vai trò' },
      { name: 'Thao tác', width: 70, maxWidth: 70, minWidth: 70 }
    ],
    TMTVCTTV: [
      { name: 'STT', width: 45 },
      { name: 'Họ và tên' },
      { name: 'Ngày sinh', width: 145, maxWidth: 145, minWidth: 145 },
      { name: 'Đơn vị' },
      { name: 'Chức vụ' },
      { name: 'Vai trò' }
    ],
    danhSachDoiTuongViPham: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng vi phạm' },
      { name: 'Lĩnh vực' },
      { name: 'Tình trạng', width: 145, maxWidth: 145, minWidth: 145 },
      { name: 'Thao tác', width: 150, maxWidth: 150, minWidth: 150 }
    ],
    danhSachDoiTuongViPhamView: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng vi phạm' },
      { name: 'Lĩnh vực' },
      { name: 'Tình trạng', width: 145, maxWidth: 145, minWidth: 145 },
    ],
    DMTTDX: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng', width: 175 },
      { name: 'Hướng đề xuất của Thanh tra tỉnh', width: 500 },
    ]
  },
  thanhTraTrung: {
    DMCTTT: [
      { name: 'STT', width: 30 },
      { name: 'Đối tượng thanh tra/kiểm tra', width: 145 },
      { name: 'Đơn vị thanh tra/kiểm tra', width: 110 },
      { name: 'Kế hoạch thanh tra/kiểm tra', width: 60 },
      { name: 'Năm thanh tra/kiểm tra', width: 65 },
      // { name: 'Tên cuộc/Số đối tượng', width: 180 },
      { name: 'Nội dung cuộc thanh tra', width: 215 },
      { name: 'Hoạt động', width: 86 },
      { name: 'Phạm vi', width: 100 },
      { name: 'Thời gian tiến hành', width: 104 },
      { name: 'Trạng thái xử lý/Gợi ý ưu tiên', width: 215 },
    ],
    DMTHCTTCDV: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra, kiểm tra/ Số đối tượng', width: 250 },
      { name: 'Nội dung thanh tra/kiểm tra', width: 400 },
      { name: 'Đơn vị thanh tra/kiểm tra', width: 315 },
      { name: 'Năm thanh tra/kiểm tra', width: 90 },
      { name: 'Số quyết định KHTT/KHKT', width: 110 },
      { name: 'Thời gian gửi KHTT/KHKT', width: 110 },
      { name: 'Hoạt động', width: 150 },
      { name: 'Tiến độ', width: 150 },
    ],
    CNNDXL: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra', width: 150 },
      { name: 'Đơn vị thanh tra', width: 90 },
      { name: 'Kế hoạch thanh tra', width: 100 },
      { name: 'Năm thanh tra', width: 80 },
      { name: 'Tên cuộc/Số đối tượng', width: 230 },
      { name: 'Chuyên viên đề xuất', width: 330 },
      { name: 'Hoạt động', width: 100 },
      { name: 'Phạm vi', width: 100 },
      { name: 'Trạng thái xử lý ĐV', width: 100 },
      { name: 'Trạng thái xử lý trùng', width: 100 },
    ],
    CNNDXLCT: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra/kiểm tra', width: 150 },
      { name: 'Đơn vị thanh tra/kiểm tra', width: 90 },
      { name: 'Kế hoạch thanh tra/kiểm tra', width: 100 },
      { name: 'Năm thanh tra/kiểm tra', width: 80 },
      { name: 'Tên cuộc/Số đối tượng', width: 230 },
      { name: 'Chuyên viên đề xuất', width: 330 },
      { name: 'Phạm vi', width: 100 },
      { name: 'Trạng thái xử lý ĐV', width: 100 },
    ],
    KHTTD: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng thanh tra/Số đối tượng', width: 120 },
      { name: 'Nội dung thanh tra/kiểm tra', width: 245 },
      { name: 'Thời hạn thanh tra/kiểm tra', width: 75 },
      { name: 'Thời kỳ thanh tra/kiểm tra', width: 140 },
      { name: 'Thời gian tiến hành', width: 110 },
      // {name: 'Đơn vị chủ trì', width: 125},
      // {name: 'Đơn vị phối hợp', width: 200},
    ],
    DSTHKHTT: [
      { name: 'STT', width: 35 },
      { name: 'Năm thanh tra/kiểm tra', width: 500 },
      { name: 'Quyết định phê duyệt KHTT/KHKT', width: 200 },
      { name: 'Ngày phê duyệt', width: 200 },
      { name: 'Đơn vị', width: 300 },
      { name: 'Số cuộc TT/KT', width: 200 },
      { name: 'Hoạt động', width: 200 },
      { name: 'Tiến độ', width: 200 },
    ],
    DSLSXLTTT: [
      { name: 'STT', width: 45 },
      { name: 'Lần xử lý', width: 150 },
      { name: 'Số quyết định' },
      { name: 'Ngày ban hành' },
      { name: 'Năm thanh tra/kiểm tra' },
      { name: 'Thời gian xử lý' },
      { name: 'Tài liệu đính kèm' },
      { name: 'Thao tác' },
    ],
    DSTB: [
      { name: 'STT', width: 35 },
      { name: 'Ngày thông báo', width: 120 },
      { name: 'Nội dung thông báo' },
      { name: 'Phân hệ', width: 100 },
      { name: 'Thao tác', width: 100 },
    ]
  },
  theoDoi: {
    tinhHinhXLDDonVi: [
      [
        { name: 'STT', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40 },
        { name: 'Tên đơn vị', className: 'txt-left', colSpan: 1, rowSpan: 2 },
        { name: 'Đang xử lý', colSpan: 2, rowSpan: 1 },
        { name: 'Đã xử lý', colSpan: 2, rowSpan: 1 },
        { name: 'Tổng số', colSpan: 1, rowSpan: 2, width: 100, maxWidth: 100, minWidth: 100 }
      ],
      [
        { name: 'Đúng hạn', width: 120, minWidth: 120 },
        { name: 'Trễ hạn', width: 120, minWidth: 120 },
        { name: 'Đúng hạn', width: 120, minWidth: 120 },
        { name: 'Trễ hạn', width: 120, minWidth: 120 }
      ]
    ],
    theoDoiDonDocTheoKy: [
      [
        { name: 'STT', colSpan: 1, rowSpan: 2, width: 40, maxWidth: 40, minWidth: 40 },
        { name: 'Đơn vị', colSpan: 1, rowSpan: 2, minWidth: 150 },
        { name: 'Tiếp nhận trong kỳ', colSpan: 1, rowSpan: 2, },
        { name: 'Kỳ trước chuyển sang', colSpan: 1, rowSpan: 2 },
        { name: 'Tổng đơn', colSpan: 1, rowSpan: 2, minWidth: 100 },
        { name: 'Đơn đang XLD, GQD', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100 },
        { name: 'Đơn đã XLD, GQD', colSpan: 1, rowSpan: 2, width: 100, minWidth: 100 }
      ]
    ],
    danhSachDonTreHan: [
      { name: 'STT', width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Mã tra cứu', className: 'txt-center' },
      { name: 'Ngày tiếp nhận' },
      { name: 'Người đứng đơn', width: 500, maxWidth: 500, minWidth: 300 },
      { name: 'Tóm tắt nội dung', width: 600, maxWidth: 600, minWidth: 300 },
      { name: 'Đơn vị xử lý, giải quyết', minWidth: 150 },
      { name: 'Phân loại đơn/Số người', minWidth: 100 },
    ],
    danhSachThongKeGiamSatDonCu: [
      { name: 'STT', width: 40, },
      { name: 'Người đứng đơn', className: 'txt-center', width: 150 },
      { name: 'Tóm tắt nội dung', width: 400, maxWidth: 600, minWidth: 300 },
      { name: 'Phân loại đơn/ Số người', width: 150 },
      { name: 'Nguồn đơn', width: 150 },
    ],
    thongKeGiamSatNhapDonCu: [
      { name: 'STT', width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'Tên đơn vị', className: 'txt-center' },
      { name: 'Số đơn đơn giản' },
      { name: 'Số đơn phức tạp' },
      { name: 'Tổng đơn' }
    ],
  },
  doiTuongThanhTra: [
    { name: 'STT', width: 45 },
    { name: 'Mã số DN', width: 90 },
    { name: 'Tên', width: 200 },
    { name: 'Loại đối tượng thanh tra', width: 150 },
    { name: 'Địa chỉ', width: 260 },
    { name: 'Số điện thoại', width: 150 },
    { name: 'Trạng thái', width: 150 },
    { name: 'Ghi chú', width: 150 },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  nhomDoiTuongThanhTra: [
    { name: 'STT', width: "5%" },
    { name: 'Tên nhóm', width: "35%" },
    { name: 'Mô tả', width: "45%" },
    { name: 'Thao tác', width: "15%", minWidth: "15%" }
  ],
  popUpCongChucSNV: [
    { name: 'STT', width: 45 },
    { name: 'Tên', width: 200 },
    { name: 'Thông tin cá nhân' },
    { name: 'Trạng thái' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  popUpDonViSNV: [
    { name: 'STT', width: 45 },
    { name: 'Tên đơn vị', width: 200 },
    { name: 'Tên cấp đơn vị', width: 200 },
    { name: 'Tên đơn vị cấp trên' },
    { name: 'Thao tác', width: 110, minWidth: 110 }
  ],
  listTraCuuTTCP: [
    { name: 'STT', width: 44 },
    { name: 'Người đứng đơn', width: 200 },
    { name: 'Số CMND', width: 150 },
    { name: 'Địa chỉ', minWidth: 200 },
    { name: 'Nội dung đơn', minWidth: 200 }
  ],
  listTraCuuDon: [
    { name: 'STT', width: 44 },
    { name: 'Mã tra cứu', width: 100 },
    { name: 'Ngày tiếp nhận', width: 95 },
    { name: 'Người đứng đơn', minWidth: 150 },
    { name: 'Tóm tắt nội dung', minWidth: 120 },
    { name: 'Phân loại đơn /Số người', width: 170 },
    { name: 'Nguồn đơn', width: 85 },
  ],
  listTraCuuDonCu: [
    { name: 'STT', width: '5%' },
    { name: 'Người đứng đơn', minWidth: '25%' },
    { name: 'Tóm tắt nội dung', minWidth: '35%' },
    { name: 'Phân loại đơn /Số người', width: '20%' },
    { name: 'Nguồn đơn', width: '15%' },
  ],
  baoCaoDinhKy: [
    { name: 'STT', width: 44 },
    { name: 'Tên báo cáo', className: 'txt-left' },
    { name: 'Kỳ báo cáo', className: 'txt-left' },
    { name: 'Năm', className: 'txt-left' },
    { name: 'Hạn nộp', className: 'txt-left' },
    { name: 'Trạng thái', className: 'txt-left' },
    { name: 'Ngày nộp', className: 'txt-left' }
  ],
  baoCaoTongHop: [
    { name: 'STT', width: 44 },
    { name: 'Tên báo cáo', className: 'txt-left' },
    { name: 'Kỳ báo cáo', className: 'txt-left' },
    { name: 'Năm', className: 'txt-left' },
    { name: 'Đơn vị đã báo cáo', className: 'txt-left' }
  ],
  baoCaoDinhKyChiTiet: [
    { name: 'STT', width: 44 },
    { name: 'Tên báo cáo', className: 'txt-left' },
    { name: 'Ngày chốt báo cáo', className: 'txt-left' },
    { name: 'Trạng thái', className: 'txt-left' },
    { name: 'Văn bản đính kèm', className: 'txt-left' }
  ],
  baoCaoTongHopDSBC: [
    { name: 'STT', width: 44 },
    { name: 'Tên báo cáo', className: 'txt-left' },
    { name: 'Trạng thái', className: 'txt-left', width: 170 },
    { name: 'Ngày tổng hợp', className: 'txt-left', width: 170 }
  ],
  chiTietDonViBCTH: [
    { name: 'STT', width: 44 },
    { name: 'Tên báo cáo', className: 'txt-left' },
    { name: 'Văn bản đính kèm', className: 'txt-left', width: 300 }
  ],
  baoCaoTongHopDSDonVi: [
    { name: 'STT', width: 44 },
    { name: 'Tên đơn vị', className: 'txt-left' },
    { name: 'Hạn nộp báo cáo', className: 'txt-left' },
    { name: 'Trạng thái', className: 'txt-left' },
    { name: 'Ngày nộp', className: 'txt-left' },
    { name: 'Thao tác', className: 'txt-left' }
  ],
  theoDoiThucHien: {
    danhSach: [
      { name: 'STT', width: 45 },
      { name: 'Đối tượng thanh tra/Số đối tượng', width: 220 },
      { name: 'Nội dung thanh tra, kiểm tra', minWidth: 80, width: 170 },
      { name: 'Hình thức/Loại hình thanh tra, kiểm tra', width: 220 },
      { name: 'Số QĐ/ Ngày ra QĐ', width: 130 },
      { name: 'Ngày chuyển theo dõi', width: 150 },
      { name: 'Số kết luận', width: 150 },
      { name: 'Trạng thái', width: 150 },
      { name: 'Thao tác', minWidth: 100, maxWidth: 100, width: 100 }
    ],
    danhSachDoiTuongViPham: [
      { name: 'STT', width: 45 },
      { name: 'Tên đối tượng vi phạm' },
      { name: 'Lĩnh vực', width: 220 },
      { name: 'Thời hạn', width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Tiến độ', width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'Thao tác', width: 150, maxWidth: 150, minWidth: 150 }
    ]
  },
  searchKHTTDialog: [
    { name: 'STT', width: 45 },
    { name: 'Quyết định phê duyệt KHTT', width: 145 },
    { name: 'Ngày phê duyệt', width: 110 },
    { name: 'Năm thanh tra', width: 110 },
    { name: 'Chức năng thanh tra', width: 150 },
    { name: 'Người ký', width: 150 },
    { name: 'Thao tác', minWidth: 200 }
  ],
  nhaNuocVeThanhTra: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'BAN HÀNH VĂN BẢN QUẢN LÝ, CHỈ ĐẠO (BỘ, NGÀNH, TỈNH, TP) VỀ CÔNG TÁC THANH TRA', className: 'middle-content', colSpan: 2, rowSpan: 2 },
      { name: 'TẬP HUẤN, TUYÊN TRUYỀN, GIÁO DỤC PHÁP LUẬT VỀ THANH TRA CHO CÁN BỘ, CÔNG CHỨC, VIÊN CHỨC, NHÂN DÂN', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'THANH TRA, KIỂM TRA TRÁCH NHIỆM', className: 'middle-content', colSpan: 9, rowSpan: 1 },
      { name: 'KIỂM TRA VIỆC THỰC HIỆN THANH TRA TRÁCH NHIỆM, QUYẾT ĐỊNH XỬ LÝ', className: 'middle-content', colSpan: 5, rowSpan: 1 },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Pháp luật về thanh tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Pháp luật về thanh tra, KNTC, PCTN', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Thực hiện pháp luật về thanh tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Thực hiện pháp luật về thanh tra, KNTC, PCTN', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Số đơn vị có vi phạm', colSpan: 1, rowSpan: 3, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Kiến  nghị xử lý', colSpan: 4, rowSpan: 1, className: 'middle-content' },

      { name: 'Tổng số KLTT và QĐ xử lý đã kiểm tra', colSpan: 1, rowSpan: 3, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Kết quả kiểm tra', colSpan: 4, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Số văn bản ban hành mới', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số văn bản được sửa đổi, bổ sung', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Lớp', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Người', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Số cuộc', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số đơn vị', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Đã kiểm điểm, rút kinh nghiệm', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Tổ chức', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Cá nhân', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
    ]
  ],
  xayDungLucLuongThanhTra: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'THỰC TRẠNG CÁN BỘ CÔNG CHỨC TRONG KỲ BÁO CÁO', className: 'middle-content', colSpan: 6, rowSpan: 1 },
      { name: 'BIẾN ĐỘNG TRONG KỲ BÁO CÁO (SỐ CBCC)', className: 'middle-content', colSpan: 7, rowSpan: 1 },
      { name: 'ĐÀO TẠO, BỒI DƯỠNG NGHIỆP VỤ THANH TRA', className: 'middle-content', colSpan: 8, rowSpan: 1 },
      { name: 'ĐÀO TẠO LÝ LUẬN CHÍNH TRỊ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, },
      { name: 'ĐÀO TẠO KHÁC (NGOẠI NGỮ, TIN HỌC, TRÊN ĐẠI HỌC)', className: 'middle-content', colSpan: 1, rowSpan: 4, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 4, width: 150, maxWidth: 150, minWidth: 150 }
    ],
    [
      { name: 'Tổng số', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Trong đó', colSpan: 5, rowSpan: 1, className: 'middle-content' },
      { name: 'Tiếp nhận, tuyển dụng', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Nghỉ hưu, chuyển công tác', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Bổ nhiệm chức vụ lãnh đạo', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Bổ nhiệm vào ngạch, nâng ngạch', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Chuyển đổi vị trí công tác', colSpan: 1, rowSpan: 3, className: 'middle-content', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao },
      { name: 'Vi phạm kỷ luật', colSpan: 2, rowSpan: 2, className: 'middle-content' },
      { name: 'Tổng số', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Trong đó', colSpan: 6, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Số TTV cao cấp và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số TTV chính và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số TTV và tương đương', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số CB, CC, VC trong biên chế', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Số lao động hợp đồng', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Nhu cầu', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Đã thực hiện', colSpan: 1, rowSpan: 2, width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Thanh tra viên', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Thanh tra viên chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },

      { name: 'Thanh tra viên cao cấp', colSpan: 2, rowSpan: 1, className: 'middle-content' },
    ],
    [
      { name: 'Phải xử lý', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Đã xử lý', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },

      { name: 'Nhu cầu', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
      { name: 'Đã thực hiện', width: widthThongKeBaoCao, minWidth: widthThongKeBaoCao, className: 'middle-content' },
    ]
  ],
  tongHopSoLieu: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'SỐ NGƯỜI PHẢI KÊ KHAI TRONG NĂM', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐÃ KÊ KHAI', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI CÔNG KHAI THEO HÌNH THỨC NIÊM YẾT', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI CÔNG KHAI THEO HÌNH THỨC TỔ CHỨC CUỘC HỌP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐƯỢC XÁC MINH TÀI SẢN, THU NHẬP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐÃ CÓ KẾT LUẬN VỀ VIỆC KÊ KHAI TÀI SẢN, THU NHẬP KHÔNG TRUNG THỰC', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ KỸ LUẬT DO KÊ KHAI TÀI SẢN, THU NHẬP KHÔNG TRUNG THỰC', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ KỸ LUẬT DO CHẬM TỔ CHỨC KÊ KHAI, CHẬM KÊ KHAI, CHẬM TỔNG HỢP, BÁO CÁO KẾT QUẢ MINH BẠCH TÀI SẢN', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'SỐ NGƯỜI ĐÃ BỊ XỬ LÝ TRÁCH NHIỆM TRONG XÁC MINH TÀI SẢN THU NHẬP', colSpan: 1, rowSpan: 1, minWidth: widthThongKeBaoCao, },
      { name: 'GHI CHÚ', className: 'middle-content', colSpan: 1, rowSpan: 1, width: 150, maxWidth: 150, minWidth: 150 }
    ]
  ],
  quanLyHoSo: {
    dsQuanLyHoSo: [
      { name: 'STT', width: 45 },
      { name: 'Mã hồ sơ' },
      { name: 'Người lưu hồ sơ' },
      { name: 'Cơ quan lưu trữ' },
      { name: 'Thời gian lưu hồ sơ' },
    ],
    dsVanBanXuLy: [
      { name: 'STT', width: 45 },
      { name: 'Tên tài liệu' },
      { name: 'Số văn bản' },
      { name: 'Ngày ra văn bản' },
      { name: 'Tài liệu đính kèm' },
    ]
  },
  quanLyVanBan: {
    dsQuanLyDanhMucVanBan: [
      { name: 'STT', width: 45 },
      { name: 'Tên văn bản' },
      { name: 'Cơ quan ban hành' },
      { name: 'Thể loại văn bản' },
      { name: 'Lĩnh vực văn bản' },
      { name: 'Thao tác', width: 180 }
    ],
    dsTheLoaiVanBan: [
      { name: 'STT', width: 45 },
      { name: 'Thể loại văn bản' },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 180 }
    ],
    dsLinhVucVanBan: [
      { name: 'STT', width: 45 },
      { name: 'Tên lĩnh vực văn bản' },
      { name: 'Thao tác', width: 180 }
    ],
    dsCoQuanBanHanhVanBan: [
      { name: 'STT', width: 45 },
      { name: 'Tên cơ quan ban hành' },
      { name: 'Thao tác', width: 180 }
    ],
    dsNhomHoSo: [
      { name: 'STT', width: 45 },
      { name: 'Tên nhóm hồ sơ' },
      { name: 'Mô tả' },
      { name: 'Thao tác', width: 180 }
    ]
  },
  dsCanCuCuocThanhTra: [
    { name: 'STT', width: 45 },
    { name: 'Tên văn bản' },
    { name: 'Cơ quan ban hành' },
    { name: 'Thể loại văn bản' },
    { name: 'Lĩnh vực văn bản' },
    { name: 'Văn bản đính kèm' },
    { name: 'Thao tác', width: 100 }
  ],
  dsCanCuCuocThanhTraView: [
    { name: 'STT', width: 45 },
    { name: 'Tên văn bản' },
    { name: 'Cơ quan ban hành' },
    { name: 'Thể loại văn bản' },
    { name: 'Lĩnh vực văn bản' },
    { name: 'Văn bản đính kèm' },
  ],
  taiLieuTrenQLVBDH: [
    { name: 'STT', width: 45 },
    { name: 'Ngày ban hành', width: 140 },
    { name: 'Số ký hiệu', width: 120 },
    { name: 'Người lập dự thảo', width: 160 },
    { name: 'Cơ quan ban hành', width: 180 },
    { name: 'Tài liệu đính kèm', width: 100 },
  ],
  thongKeBaoCaoThanhTraThamNhung: [
    [
      { name: 'STT', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 40, maxWidth: 40, minWidth: 40 },
      { name: 'ĐƠN VỊ PHÁT HIỆN', className: 'middle-content', colSpan: 1, rowSpan: 3, width: 220, maxWidth: 220, minWidth: 220 },
      { name: 'SỐ VỤ', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn },
      { name: 'SỐ NGƯỜI', className: 'middle-content', colSpan: 1, rowSpan: 3, width: widthColumn, minWidth: widthColumn },

      { name: 'TÀI SẢN THAM NHŨNG', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KIẾN NGHỊ THU HỒI', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'ĐÃ THU', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KIẾN NGHỊ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'KẾT QUẢ XỬ LÝ', className: 'middle-content', colSpan: 4, rowSpan: 1 },
      { name: 'XỬ LÝ TRÁCH NHIỆM NGƯỜI ĐỨNG ĐẦU', className: 'middle-content', colSpan: 2, rowSpan: 2 }
    ],
    [
      { name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Tổng tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tiền (Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Tài sản khác (quy đổi ra tiền Trđ)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },
      { name: 'Đất (m2)', colSpan: 1, rowSpan: 2, width: widthCostColumn, minWidth: widthCostColumn, className: 'middle-content' },

      { name: 'Hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Chuyển cơ quan điều tra', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã xử lý hành chính', colSpan: 2, rowSpan: 1, className: 'middle-content' },
      { name: 'Đã khởi tố', colSpan: 2, rowSpan: 1, className: 'middle-content' }
    ],
    [
      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Tổ chức', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Cá nhân', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Vụ', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đối tượng', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },

      { name: 'Kiến nghị', width: widthColumn, minWidth: widthColumn, className: 'middle-content' },
      { name: 'Đã xử lý', width: widthColumn, minWidth: widthColumn, className: 'middle-content' }
    ]
  ],
};

export { header };



// WEBPACK FOOTER //
// ./src/constants/table.js